import { render, staticRenderFns } from "./AddPrescription.vue?vue&type=template&id=0269cd00&scoped=true&"
import script from "./AddPrescription.vue?vue&type=script&lang=js&"
export * from "./AddPrescription.vue?vue&type=script&lang=js&"
import style0 from "./AddPrescription.vue?vue&type=style&index=0&id=0269cd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0269cd00",
  null
  
)

export default component.exports